export default "__VITE_ASSET__B6N3vKVC__"